module.exports = function(){return "";};


//////////////////
// WEBPACK FOOTER
// ./resources/templates/layouts/metrics.hbs
// module id = 233
// module chunks = 0